import styled from 'styled-components';
export var CouponContainer = styled.div.withConfig({
  componentId: "sc-1em7l4r-0"
})(["margin:15px 0px;"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/components/Coupon/styled.js
// module id = 4658
// module chunks = 11